import { NgModule } from '@angular/core';

@NgModule({
  imports: [],
  exports: [],
})
export class ProductUpdatesModule {}
